module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_02.a5e76055.jpg";